<template lang="html">
 <section class="widgets">
  <div class="row">
   <div id='loadingmessage' style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;" v-if="loading">
                            <p style="position: absolute; color: White; top: 40%; left: 40%;">
                                <img src='../../assets/snakes.gif' /></p>
                        </div>
    <div class="col-md-12 grid-margin">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title mb-0">Approved Operations </h4><br>
          <div>
            <div class="justify-content-centermy-1 row">
                 <b-form-fieldset horizontal label="Rows per page" class="col-6">
                  <b-form-select :options="[{text:20,value:20},{text:30,value:30},{text:50,value:50}]" v-model="perPage">
                  </b-form-select>
                </b-form-fieldset>

                <b-form-fieldset horizontal label="Filter" class="col-6">
                  <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                </b-form-fieldset>
              </div>
              <template>
                <b-table striped hover :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" style="font-weight: 200;">
                <template v-slot:cell(reportedAt)="row">
                 {{row.item.reportedAt.slice(0,10)}}
                    </template>

                   <template v-slot:cell(_id)="row">
  <router-link :to="'/approvedDetails/' + row.item._id" target="_blank">
    <b-button variant="success">View Details</b-button>
  </router-link>
</template>
                    
                   <template v-slot:cell(pic)="row">
  <enlargeable-image
    v-bind:src="'https://sarpatnapi.leopardtechlabs.in/u/' + row.item.pic"
    v-bind::src_large="'https://sarpatnapi.leopardtechlabs.in/u/' + row.item.pic"
  >
    <img
      v-bind:src="'https://sarpatnapi.leopardtechlabs.in/u/' + row.item.pic"
      width="50px"
      height="50px"
    />
  </enlargeable-image>
</template>
<template v-slot:cell(description)="row">
   <button class="btn btn-danger" @click="rejectItem(row)">Delete</button>
</template>
                   
                </b-table>
              </template>
               <div class="justify-content-center row my-1">
                <b-pagination size="md" :total-rows="this.items.length" :per-page="perPage" v-model="currentPage" />
              </div>
              </div>
             
        </div>
        
     </div>
    </div>
  </div>
  </section>
 </template>
<script>
import axios from "axios";
import EnlargeableImage from "@diracleo/vue-enlargeable-image";
export default {
  components: {
    EnlargeableImage,
  },
  name: "news",
  data() {
    return {
      items: [],
      status: false,
      fields: [
        {
          key: "reportedAt",
          label: "Date",
          sortable: true,
        },
        
        {
          key: "pic",
          label: "Image",
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
        {
          key: "snake",
          label: "Snake",
          sortable: true,
        },
        {
          key: "_id",
          label: "Action",
        },
        {
          key: "description",
          label: "Delete",
          sortable: true,
        },
      ],
      currentPage: 1,
      perPage: 20,
      filter: null,
      striped: true,
      loading: false,
    };
  },
  mounted: function () {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      axios({
        url: "https://sarpatnapi.leopardtechlabs.in/operation/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data && response.data.data) {
            // this.status = response.data.status;
            this.items = response.data.data;
            var temp = [];
            for (var i = 0; i < this.items.length; i++) {
              var it = this.items[i].reportId;
              it.status = this.items[i].status;
              it._id = this.items[i]._id;
              it.reportedAt = this.items[i].reportedAt;
              if (this.items[i].reportId.snake)
                it.snake = this.items[i].reportId.snake.name;
              temp.push(it);
            }
            this.items = temp;
          } else {
            this.items = [];
          }
          this.loading = false;
        })
        .catch((e) => {
          this.items = [];
          this.loading = false;
        });
    },
    rejectItem: function (item) {
       if (confirm("Are you sure?")) {
      var vm = this;
      vm.item = item.item._id;
      axios({
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        url: "https://sarpatnapi.leopardtechlabs.in/operation/delete",
        data: {
          id: vm.item,
        },
      })
        .then((response) => {
          alert("Report was successfully Deleted");
          this.getList();
        })
        .catch((e) => {});
       }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/forms/deletelocations.vue